import { isBefore } from 'date-fns';
import { useFeatureFlag } from '@ibk/shared-feature-flags';
import { FeatureFlagUseCase } from '@ibk/shared-types';
import { useBenefitContract } from './useBenefitContract';
const happyHolidaysEndOfTheYearEndDate = new Date('2027-01-01T00:00:00');
export function useHappyHolidaysEndOfTheYearRecharge() {
    const { contractData } = useBenefitContract();
    const { isFeatureFlagWhiteListed } = useFeatureFlag();
    const isCampaignEnabled = isFeatureFlagWhiteListed(FeatureFlagUseCase.BENEFICIOS_RECARGA_BOAS_FESTAS);
    const isHappyHolidaysEndOfTheYearRechargePeriod = isCampaignEnabled && isBefore(new Date(), happyHolidaysEndOfTheYearEndDate);
    const isTermAccepted = contractData?.isHappyHolidaysEndOfTheYearTermAccepted ?? false;
    return {
        isInPeriod: isHappyHolidaysEndOfTheYearRechargePeriod,
        isTermAccepted,
    };
}
